// Full "Rebulk" wordmark (long logo). Same treatment as the square
// <RebulkLogo>: the lettering uses `currentColor` so it follows
// `text-black dark:text-white`, while the flag keeps the brand yellow.
// Color source = rebulk-logos/color, inverse = the same paths rendered
// white via currentColor in dark mode.
export const RebulkWordmark = ({ className }: { className?: string }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1775.65 582.28"
    className={className}
  >
    <path
      fill="currentColor"
      d="M290.42,346.4c45.62-11.54,71.84-36.71,71.84-82.33v-45.1c0-67.65-55.58-91.77-145.26-91.77h-117.99v354.49c23.07,2.1,53.49,2.1,76.56,0v-127.43h38.28c29.89,40.9,54.54,86.53,73.94,127.43,22.55,2.1,57.68,2.1,80.23,0-20.45-43.52-46.15-92.29-77.61-135.3ZM205.7,276.38l-30.12,13.39v-97.9l28.53,12.68,81.6,36.27-80,35.56Z"
    />
    <polygon
      fill="#fdc11a"
      points="99.02 127.2 99.02 354.44 175.58 289.77 175.58 191.88 99.02 127.2"
    />
    <path
      fill="currentColor"
      d="M642.03,363.7c-35.13,2.62-115.89,3.15-160.99.53v13.11c0,37.23,21.5,44.05,66.6,44.05,30.94,0,52.96-2.62,82.33-8.39,2.1,17.83,2.1,43,0,60.83-36.71,6.29-66.07,9.44-100.68,9.44-75.51,0-123.23-22.55-123.23-89.15v-104.88c0-69.74,50.34-90.19,120.08-90.19s115.89,29.36,115.89,104.35v60.3ZM568.62,300.25c0-35.66-20.45-39.85-43.52-39.85s-44.05,4.19-44.05,39.85v20.45l40.38-2.62h47.2v-17.83Z"
    />
    <path
      fill="currentColor"
      d="M937.26,404.08c0,58.21-38.8,79.18-89.67,79.18-43,0-74.46-11.01-84.43-44.05h-3.15l-4.72,38.81c-17.31,2.1-49.29,2.1-66.6,0V100.98c17.83-2.62,56.63-2.62,74.99,0v98.06l-3.67,44.57h3.15c9.96-33.03,41.43-44.57,84.43-44.57,50.86,0,89.67,20.98,89.67,79.18v125.85ZM862.27,311.79c0-43-18.88-48.77-45.62-48.77-32.51,0-43.52,7.87-52.97,37.23v81.28c9.44,29.37,20.45,37.23,52.97,37.23,26.74,0,45.62-5.77,45.62-48.24v-58.73Z"
    />
    <path
      fill="currentColor"
      d="M1160.12,439.21h-3.15c-9.44,33.04-41.43,44.05-84.95,44.05-50.87,0-88.62-19.93-88.62-77.61v-198.75c18.35-2.62,57.16-2.62,74.99,0v164.14c0,41.95,19.4,48.24,45.1,48.24,32.51,0,44.57-8.91,52.96-37.23v-175.15c18.35-2.62,57.16-2.62,74.99,0v271.64c-17.3,2.62-49.29,2.62-66.6,0l-4.72-39.33Z"
    />
    <path
      fill="currentColor"
      d="M1289.12,100.98c17.83-2.62,56.63-2.62,74.99,0v375.99c-18.35,2.62-57.16,2.62-74.99,0V100.98Z"
    />
    <path
      fill="currentColor"
      d="M1522.99,356.88l-26.22,3.67v116.41c-18.35,2.62-57.16,2.62-74.99,0V100.98c17.83-2.62,56.63-2.62,74.99,0v195.6l29.36-4.19,66.07-89.15c17.3-2.62,63.45-2.62,80.76,0l-88.1,120.09,91.77,153.65c-17.3,2.62-63.97,2.62-81.8,0l-71.84-120.09Z"
    />
  </svg>
)

export default RebulkWordmark
